import type { Icon } from '../../../src/lib/types'
export const mdiChevronRight: Icon = {
  "id": "chevron-right",
  "name": "Chevron Right",
  "path": "M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z",
  "as": [
    "keyboard-arrow-right",
    "navigate-next"
  ],
  "tags": [
    "Arrow"
  ]
}
export default mdiChevronRight